import { MembershipType } from 'common/types/MemberProfile'

interface ButtonBg {
  default: string
  hover: string
}

export interface MembershipExtendedColors {
  cardBg: string
  avatarBg: string
  teamSectionBg: string
  avatarStrokeColor: string
  buttonBg: ButtonBg
  bioLeftBorder: string
  teamMemberShadow: string
}

interface MembershipShortColors {
  headerBg: string
  footerBg: string
  initialsBorder: string
}

export const getMembershipExtendedColors = (
  membershipType: MembershipType,
): MembershipExtendedColors => {
  const colors = {
    NONE: {
      cardBg: 'bg-[rgba(101,150,215,0.5)]',
      avatarBg: 'bg-[rgba(101,150,215,0.5)]',
      teamSectionBg:
        'linear-gradient(0deg, white -10%, rgba(101,150,215,0.35) 30%, rgba(101,150,215,0.35) 40%, white 80%)',
      avatarStrokeColor: 'text-[#6596D7]',
      buttonBg: {
        default: 'bg-[#6596D7]',
        hover: 'hover:bg-[#456792]',
      },
      bioLeftBorder: 'border-[#6596D7]',
      teamMemberShadow: 'shadow-[0px_0px_10px_3px_rgba(101,150,215,0.25)]',
    },
    STANDARD: {
      cardBg: 'bg-[rgba(88,193,179,0.5)]',
      avatarBg: 'bg-[rgba(88,193,179,0.5)]',
      teamSectionBg:
        'linear-gradient(0deg, white -10%, rgba(88,193,179,0.35) 30%, rgba(88,193,179,0.35) 40%, white 80%)',
      avatarStrokeColor: 'text-[#58C1B3]',
      buttonBg: {
        default: 'bg-[#58C1B3]',
        hover: 'hover:bg-gradient-to-r from-[#58C1B3] to-[#5DA99F]',
      },
      bioLeftBorder: 'border-[#58C1B3]',
      teamMemberShadow: 'shadow-[0px_0px_10px_3px_rgba(88,193,179,0.25)]',
    },
    PREMIUM: {
      cardBg: 'bg-[rgba(132,132,246,0.5)]',
      avatarBg: 'bg-[rgba(132,132,246,0.5)]',
      teamSectionBg:
        'linear-gradient(0deg, white -10%, rgba(132, 132, 246, 0.35) 30%, rgba(132, 132, 246, 0.35) 40%, white 80%)',
      avatarStrokeColor: 'text-[#7B83EB]',
      buttonBg: {
        default: 'bg-[#7B83EB]',
        hover: 'hover:bg-gradient-to-r from-[#8484F6] to-[#6363AE]',
      },
      bioLeftBorder: 'border-[#7B83EB]',
      teamMemberShadow: 'shadow-[0px_0px_10px_3px_rgba(123,131,235,0.25)]',
    },
    COMMISSION: null,
  }

  colors.COMMISSION = { ...colors.STANDARD }
  return colors[membershipType] || colors.NONE
}

export const getMembershipShortColors = (
  membershipType: string,
): MembershipShortColors => {
  const colors = {
    NONE: {
      headerBg: `linear-gradient(170deg, #6596d7 -35.62%, #ccdff8 50%, transparent 26%)`,
      footerBg: 'bg-[#6596d7]',
      initialsBorder: '!border-b-[#6596d7] !border-l-[#6596d7]',
    },
    STANDARD: {
      headerBg: `linear-gradient(170deg, #58c1b3 -35.62%, #d1eeea 50%, transparent 26%)`,
      footerBg: 'bg-[#58c1b3]',
      initialsBorder: '!border-b-[#58c1b3] !border-l-[#58c1b3]',
    },
    PREMIUM: {
      headerBg: `linear-gradient(170deg, #7b83eb -35.62%, #e3e3fa 50%, transparent 26%)`,
      footerBg: 'bg-[#7b83eb]',
      initialsBorder: '!border-b-[#7b83eb] !border-l-[#7b83eb]',
    },
    COMMISSION: null,
  }

  colors.COMMISSION = { ...colors.STANDARD }
  return colors[membershipType] || colors.NONE
}
